import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Row,
  Col,
  Nav,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { FormSection } from "redux-form"
import MenuFeaturesTab from "./menuFeaturesTab"
import StyleTab from "./styleTab"

const MenuTab = ({
  handleSave,
  handleBack,
  tabIsActive,
  setSubTabBreadcrumb,
}) => {
  const TABS = {
    DESIGN: 1,
    MENU: 2,
  }

  const [activeTab, setActiveTab] = useState(TABS.DESIGN)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (tabIsActive) {
      setActiveTab(TABS.DESIGN)
      setSubTabBreadcrumb("Design", () => {
        setActiveTab(TABS.DESIGN)
      })
    }
  }, [tabIsActive])

  useEffect(() => {
    setSubTabBreadcrumb(activeTab === 1 ? "Design" : "Menu Items", () => {
      setActiveTab(TABS.DESIGN)
    })
  }, [activeTab])

  return (
    <Row className="mt-3">
      <Col xs="auto ms-5">
        <Nav pills className="flex-column">
          <NavLink
            className={markIfIsActive(TABS.DESIGN)}
            onClick={() => setActiveTab(TABS.DESIGN)}
            style={
              activeTab === TABS.DESIGN ? {} : { backgroundColor: "#eff2f7" }
            }
          >
            {<span style={{ fontSize: "16px" }}>Design</span>}
          </NavLink>
          <NavLink
            className={markIfIsActive(TABS.MENU)}
            onClick={() => setActiveTab(TABS.MENU)}
            style={
              activeTab === TABS.MENU ? {} : { backgroundColor: "#eff2f7" }
            }
          >
            {<span style={{ fontSize: "16px" }}>Menu Items</span>}
          </NavLink>
        </Nav>
      </Col>
      <Col>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={TABS.DESIGN}>
            <FormSection name="style">
              <StyleTab
                handleSave={handleSave}
                handleBack={handleBack}
                handleNext={() => setActiveTab(TABS.MENU)}
                tabIsActive={tabIsActive && activeTab === TABS.DESIGN}
              />
            </FormSection>
          </TabPane>
          <TabPane tabId={TABS.MENU}>
            <MenuFeaturesTab />
            <Row className="my-3">
              <Col className="my-1">
                <SaveButton
                  type="button"
                  onClick={() => setActiveTab(TABS.DESIGN)}
                >
                  Back
                </SaveButton>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  )
}

export default MenuTab
